import { render, staticRenderFns } from "./EditPhoto.vue?vue&type=template&id=3f06cc43&"
import script from "./EditPhoto.vue?vue&type=script&lang=ts&"
export * from "./EditPhoto.vue?vue&type=script&lang=ts&"
import style0 from "./EditPhoto.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports